const textContent = [];

export default textContent;
